import React, { useEffect, useState } from "react";
import DASHBOARD_API from "../../apis/dashboard.api";
import { useLocation, useHistory } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";

function Oauth() {
  const location = useLocation();
  const history = useHistory();
  const [loading,setLoading]= useState(false);

  const handleCallback = async (code) => {
    try {
      setLoading(true)
      let res = await DASHBOARD_API.saveGoogleToken({
        code: code,
      });
      setLoading(false)
      if (res) {
        console.log("saveGoogleToken==>", res.tokens.access_token);
        localStorage.setItem("googleAccessToken", res.tokens.access_token);
        localStorage.setItem("googleRefreshToken", res.tokens.refresh_token);
        history.push("/dashboard");
      }
      
    } catch (error) {
      setLoading(false)
      console.log("error while trying to save google auth token==>", error);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    console.log("code is===>" + code);

    if (code) {
      handleCallback(code);
    }
  }, [location]);
  return <React.Fragment><Loader isLoading={loading}/></React.Fragment>;
}

export default Oauth;
